"use strict";
exports.__esModule = true;
exports.ActionType = void 0;
var ActionType;
(function (ActionType) {
    ActionType["SHOW_ADD_FORM"] = "SHOW_ADD_FORM";
    ActionType["HIDE_ADD_FORM"] = "HIDE_ADD_FORM";
    ActionType["SELECT_ROW"] = "SELECT_ROW";
    ActionType["REMOVE_DETAIL"] = "REMOVE_DETAIL";
    ActionType["DELETE_ITEM"] = "DELETE_ITEM";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
